import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useDispatch } from 'react-redux';

import { resultsDetailsModalActions } from '../../../../../../redux/healthboard/patientPortal/results-details-modal';
import Icon from '../../../../../Icon';
import PrivacyIcon from '../../../../../PrivacyIcon';
import { formatDate } from '../../../../utils';
import styles from '../index.styl';

const LabTestResultCard = ({ entity, detailsMode }) => {
  const { name, specimenCollectionDate, orderedBy, isPrivate } = entity;
  const dispatch = useDispatch();
  const handleOpenDetails = () => {
    dispatch(
      resultsDetailsModalActions.open({ ccdLabTestId: entity.id, entity }),
    );
  };
  return (
    <div
      className={cn(styles.root, styles.labTestResult, {
        [styles.labTestResultDetails]: detailsMode,
      })}
      onClick={handleOpenDetails}
    >
      <div className={styles.header}>
        <div className={styles.leftSideWrapper}>
          {!detailsMode && (
            <Icon size={28} name="icon-lab-black" className={styles.iconType} />
          )}
          <div className={styles.contentWrapper}>
            <div className={cn(styles.title, styles.cropConditionsTitle)}>
              <div
                className={cn(styles.titleWrapper, { [styles.noTitle]: !name })}
              >
                {name}
              </div>
              <PrivacyIcon
                show={isPrivate && !detailsMode}
                className={styles.visibilityIcon}
              />
            </div>
            <div className={cn(styles.description, styles.cropConditionsTitle)}>
              {orderedBy || ''}
            </div>
          </div>
        </div>
        <div className={styles.statusWrapper}>
          <div className={styles.description}>
            {specimenCollectionDate
              ? formatDate(specimenCollectionDate, 'MMM D, Y')
              : ''}
          </div>
        </div>
      </div>
    </div>
  );
};

LabTestResultCard.propTypes = {
  entity: PropTypes.object,
  detailsMode: PropTypes.bool,
};

export default LabTestResultCard;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/index.jsx